/**
 * Extracts the clean ID from an Algolia object ID
 * Algolia object IDs are in the format "type~id" (e.g., "course~abc123")
 * This function returns just the ID part
 */
export const getCleanIdFromObjectId = (hitId: string): string | undefined => hitId?.split('~')[1];
